import React from "react";
import env from "../../env";

// reCAPTCHA v2 "I'm not a robot" checkbox.
// Rendered explicitly with the v2 site key on top of the existing v3 script
// (api.js?render=<v3 key>), so both versions run on the same page.
export function useRecaptchaCheckbox() {
  const siteKey = env.reCaptchaV2SiteKey;
  const enabled = !!siteKey;
  const containerRef = React.useRef(null);
  const widgetIdRef = React.useRef(null);
  const [token, setToken] = React.useState(null);

  React.useEffect(() => {
    if (!enabled || typeof window === "undefined") return;
    let cancelled = false;
    let timer = null;

    function tryRender() {
      if (cancelled) return;
      const grecaptcha = window.grecaptcha;
      if (!grecaptcha || !grecaptcha.render) {
        timer = setTimeout(tryRender, 300);
        return;
      }
      grecaptcha.ready(function () {
        if (cancelled || !containerRef.current || widgetIdRef.current !== null)
          return;
        widgetIdRef.current = grecaptcha.render(containerRef.current, {
          sitekey: siteKey,
          callback: (value) => setToken(value),
          "expired-callback": () => setToken(null),
          "error-callback": () => setToken(null),
        });
      });
    }
    tryRender();

    return () => {
      cancelled = true;
      if (timer) clearTimeout(timer);
    };
  }, [enabled, siteKey]);

  function reset() {
    setToken(null);
    if (widgetIdRef.current !== null && window.grecaptcha) {
      window.grecaptcha.reset(widgetIdRef.current);
    }
  }

  const element = enabled ? (
    <div className='recaptchaCheckbox' ref={containerRef}></div>
  ) : null;

  return { enabled, token, reset, element };
}
